import { render, staticRenderFns } from "./ValidJoinRequest.vue?vue&type=template&id=a2a863b0&scoped=true"
import script from "./ValidJoinRequest.vue?vue&type=script&lang=js"
export * from "./ValidJoinRequest.vue?vue&type=script&lang=js"
import style0 from "./ValidJoinRequest.vue?vue&type=style&index=0&id=a2a863b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a863b0",
  null
  
)

export default component.exports